"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import QuickChatIcon from "@/assets/svg/quick-chat.svg";
const QuickChatButton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <QuickChatWrapper><QuickChatIcon className="size-5.5 md:w-[24px] md:h-[24px]" /></QuickChatWrapper>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export function QuickChatWrapper(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  const handleClick = _temp;
  let t1;
  if ($[0] !== children) {
    t1 = <div onClick={handleClick}>{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp() {
  if (window.quickChatApi && typeof window.quickChatApi.chat === "function") {
    window.quickChatApi.chat();
  } else {
    console.warn("QuickCEP chat API is not available. Please ensure the script is loaded.");
  }
}
export default QuickChatButton;